import { Component, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { NotificationCampaign } from '../../core/models/api.models';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
})
export class NotificationsComponent implements OnInit {
  private readonly api = inject(ApiService);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly rows = signal<NotificationCampaign[]>([]);
  readonly page = signal(1);
  readonly limit = signal(20);
  readonly total = signal(0);
  readonly selectedCampaign = signal<NotificationCampaign | null>(null);
  readonly loadingDetail = signal(false);

  ngOnInit(): void {
    this.loadCampaigns();
  }

  loadCampaigns(page = this.page()): void {
    this.loading.set(true);
    this.error.set(null);
    this.api.getNotificationCampaigns(page, this.limit()).subscribe({
      next: (data) => {
        this.rows.set(data.rows || []);
        this.page.set(data.page);
        this.limit.set(data.limit);
        this.total.set(data.total);
        this.loading.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load campaigns');
        this.loading.set(false);
      },
    });
  }

  totalPages(): number {
    return Math.max(1, Math.ceil(this.total() / this.limit()));
  }

  prev(): void {
    if (this.page() > 1) this.loadCampaigns(this.page() - 1);
  }

  next(): void {
    if (this.page() < this.totalPages()) this.loadCampaigns(this.page() + 1);
  }

  viewCampaign(row: NotificationCampaign): void {
    if (this.selectedCampaign()?.id === row.id) {
      this.selectedCampaign.set(null);
      return;
    }

    this.loadingDetail.set(true);
    this.error.set(null);
    this.api.getNotificationCampaign(row.id).subscribe({
      next: (campaign) => {
        this.selectedCampaign.set(campaign);
        this.loadingDetail.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load campaign');
        this.loadingDetail.set(false);
      },
    });
  }
}
